/**
 * Avancement réglementaire d'un dossier — un seul jeu de clés à recharger
 * (lot H1).
 *
 * Toute action qui fait avancer (ou reculer) la frise d'un dossier — générer
 * le DER, la lettre de mission, le PDF du profil ou le rapport d'adéquation,
 * marquer signé / annuler la signature, valider le profil, relire le
 * recueil, envoyer / relancer / révoquer une invitation, retirer une pièce —
 * appelle `invalidateDossierProgress`. Ainsi l'accueil (« Mes dossiers en
 * cours », « Envois en cours », « À traiter maintenant »), la page Clients,
 * la frise du dossier, la file « À faire » et les notifications passent à
 * l'étape suivante tout de suite, où que l'action ait été faite.
 *
 * Clés écrites en clair (et non importées des modules `der.ts`, …) : ces
 * modules appellent ce helper, l'inverse créerait un cycle d'import.
 */

import type { QueryClient, QueryKey } from "@tanstack/react-query";

/** Écrans transverses : accueil, Clients, file « À faire », notifications, Conformité. */
const SHARED_KEYS: readonly QueryKey[] = [
  ["clients"],
  ["client-files"],
  ["dashboard"],
  ["regulatory-cockpit"],
  ["signatures"],
  ["documents"],
  ["crm"],
];

/** Entrées de la frise d'un dossier (`useRegulatoryTimeline`) et ses pièces. */
const DOSSIER_KEY_PREFIXES: readonly (readonly string[])[] = [
  ["regulatory-readiness"],
  ["der", "versions"],
  ["lettre-mission", "versions"],
  ["investor-profile-pdf", "versions"],
  ["adequation-pdf", "versions"],
  ["invitations", "list"],
  ["document-coverage"],
  ["required-documents", "list"],
];

/** Les clés rechargées — `cfId` restreint celles de la frise à ce dossier. */
export function dossierProgressKeys(cfId?: string | null): QueryKey[] {
  return [
    ...SHARED_KEYS,
    ...DOSSIER_KEY_PREFIXES.map((prefix) => (cfId ? [...prefix, cfId] : [...prefix])),
  ];
}

export function invalidateDossierProgress(qc: QueryClient, cfId?: string | null): void {
  for (const queryKey of dossierProgressKeys(cfId)) {
    void qc.invalidateQueries({ queryKey });
  }
}
